export const DENIED = 'DENIED';
export const NEUTRAL = 'NEUTRAL';
export const APPROVED = 'APPROVED';
export const FAILED = 'FAILED';

export const IDENTIFIERS = {
  [DENIED]: 1,
  [NEUTRAL]: 2,
  [APPROVED]: 3,
  [FAILED]: '_failed_',
};

export const TITLES = {
  [DENIED]: 'Sem chance de aprovação',
  [NEUTRAL]: 'Com chance de aprovação',
  [APPROVED]: 'Com grandes chances de aprovação',
  [FAILED]: 'Sem condição disponível',
};

export const COLORS = {
  [DENIED]: 'red',
  [NEUTRAL]: 'blue',
  [APPROVED]: 'green',
  [FAILED]: 'orange',
};

function keyed(original) {
  return Object.keys(original).reduce((reduced, reducing) => {
    const id = IDENTIFIERS[reducing] || reducing;

    reduced[id] = reducing;

    return reduced;
  }, {});
}

export const KEYED_IDENTIFIERS = keyed(IDENTIFIERS);
export const KEYED_TITLES = keyed(TITLES);
export const KEYED_COLORS = keyed(COLORS);

export function identifier(status) {
  return status === 0 ? 1 : (status || 2);
}

export function title(id) {
  return TITLES[KEYED_TITLES[id]];
}

export function color(id) {
  return COLORS[KEYED_COLORS[id]];
}

// export default {
//   1: 'Sem chance de aprovação',
//   2: 'Com chance de aprovação',
//   3: 'Com grandes chances de aprovação',
// };

// export const COLORS = {
//   1: 'red',
//   2: 'blue',
//   3: 'green',
// };
